import React, { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { supabase } from '../supabaseClient';

const PatientBusyAlert = ({ appointment }) => {
  const [busyMatch, setBusyMatch] = useState(null);

  useEffect(() => {
    if (!appointment) return;
    let isMounted = true;
    
    const checkBusy = async () => {
      try {
        // Get today's local date YYYY-MM-DD
        const d = new Date();
        const offset = d.getTimezoneOffset() * 60000;
        const localDate = new Date(d.getTime() - offset).toISOString().split('T')[0];

        const { data, error } = await supabase.from('appointments')
          .select('id, patient_name, patient_dni, study_details, professional_name, consultorio_name, status')
          .eq('appointment_date', localDate)
          .neq('id', appointment.id)
          .in('status', ['en-llamado', 'en-consultorio']);

        if (error || !data || data.length === 0) return;

        const targetDni = appointment.study_details?.patient_dni || appointment.patient_dni;
        const targetName = appointment.patient_name?.toLowerCase().trim();

        const match = data.find(other => {
          const otherDni = other.study_details?.patient_dni || other.patient_dni;
          const otherName = other.patient_name?.toLowerCase().trim();
          
          if (targetDni && otherDni && targetDni === otherDni) return true;
          if (targetName && otherName && targetName === otherName) return true;
          return false;
        });

        if (match && isMounted) {
           setBusyMatch(match);
        }
      } catch (e) {
        console.error(e);
      }
    };
    
    checkBusy();
    return () => { isMounted = false; };
  }, [appointment]);

  if (!busyMatch) return null;

  return (
    <div style={{ 
      background: 'rgba(255, 165, 0, 0.15)', 
      color: '#ffa500', 
      padding: '8px 12px', 
      borderRadius: '6px', 
      fontSize: '12px', 
      display: 'flex', 
      alignItems: 'center', 
      gap: '8px', 
      marginBottom: '12px', 
      border: '1px solid rgba(255, 165, 0, 0.3)' 
    }}>
      <AlertCircle size={14} />
      <span><strong>Atención:</strong> El paciente está siendo atendido en <strong>{busyMatch.consultorio_name || busyMatch.professional_name || 'otra sala'}</strong>.</span>
    </div>
  );
};

export default PatientBusyAlert;
